import { Injectable } from '@angular/core';
import { ApiService } from '@utility/http/api.service';
import { Quote } from './quote';
import { Params } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class QuotesService extends ApiService<Quote, Params, Params> {
    protected baseUrl = 'quotes';
}
